import React from "react"
import { observer } from "mobx-react"
import styled from "styled-components"
import ReactModal from "react-modal"
import Link from "next/link"
import { useRouter } from "next/router"

import useInject from "~/hooks/useInject"
import Spacer from "~/components/Spacer"
import WinItButton from "~/components/WinItButton"
import MODAL_STYLES from "~/components/modals/styles"
import AppStoreButton from "~/public/static/images/svg/AppStoreButton.svg"
import GooglePlayButton from "~/public/static/images/svg/GooglePlayButton.svg"

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const ModalTitle = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextBold};
  font-size: 1.5em;
  text-align: center;
  max-width: 550px;
`

const StoresContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 450px;
  flex-wrap: wrap;
  ${(props) => props.theme.media.tiny`
    width: 300px;
    justify-content: center;
  `};
`

const DownloadButton = styled.img`
  width: 141px;
  ${(props) => props.theme.media.tiny`
    width: 120px;
    object-fit: contain;
  `};
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  margin-top: 0.5em;
`

const mapStore = (store) => ({
  auth: store.auth,
  isMobile: store.ui.isMobile,
  user: store.auth.user,
})

const BlockedModal = () => {
  const { auth, isMobile, user } = useInject(mapStore)
  const router = useRouter()
  return (
    <ReactModal
      closeTimeoutMS={300}
      isOpen={
        auth.isUserBlocked &&
        !user.accountDeleted &&
        router.pathname !== "/contact"
      }
      style={
        isMobile ? MODAL_STYLES.mobile.general : MODAL_STYLES.desktop.general
      }
      onRequestClose={() => {}}
    >
      <ModalContainer>
        <ModalTitle>
          Download the app to unlock your account or contact support.
        </ModalTitle>
        <Spacer mobile={16} desktop={16} />
        <StoresContainer>
          <a href="https://itunes.apple.com/us/app/winit-fight-your-tickets/id929918279">
            <DownloadButton src={AppStoreButton} alt={"App Store"} />
          </a>
          <Spacer mobile={16} desktop={16} direction="width" />
          <a href="https://play.google.com/store/apps/details?id=com.winitllc.ticketfighter">
            <DownloadButton src={GooglePlayButton} alt={"Google Play"} />
          </a>
          <ButtonContainer>
            <Link href="/contact" passHref>
              <WinItButton
                as="a"
                color="green"
                width="100%"
                height={70}
                fontSize="1rem"
              >
                Contact Support
              </WinItButton>
            </Link>
          </ButtonContainer>
        </StoresContainer>
      </ModalContainer>
    </ReactModal>
  )
}

export default observer(BlockedModal)
